<div [formGroup]="blockFormGroup">
  <div formArrayName="blockFormArray">
    <div *ngFor="let opt of questionArr?.controls; let i = index" [formGroupName]="i">
      <app-add-question-button action="before" [preview]="preview" [isBlock]="true" (doAction)="questionAction($event)">
        <app-advanced-properties [model]="model"></app-advanced-properties>
        <div *ngIf="preview">
          <div class="question-var-container" (click)="click()">
            <div class="column-flex auto-flex fullWidth">
              <div class="ml-15 auto-flex">[{{ model.QuestionName }}]</div>
              <div class="auto-flex">
                <diy-player #canvas [show]="show" [model]="previewModel" [showJson]="false" [preview]="true"></diy-player>
              </div>
            </div>
            <div class="question-icon">
              <mat-icon>article</mat-icon>
            </div>
          </div>
        </div>
        <div *ngIf="!preview">
          <div class="fullWidth">
            <mat-form-field appearance="outline">
              <mat-label>Question Identity</mat-label>
              <input matInput formControlName="qNumber" [patterns]="customPatterns" mask="SA*">
            </mat-form-field>
          </div>
        </div>
        <div id="blockContentInside" #blockContent></div>
        <div *ngIf="(this.target?.length ?? 0) == 0" class="qe-block-addQnBtn-div">
          <button mat-flat-button (click)="addNewQuestion()" color="accent"><mat-icon>add</mat-icon> Add question to block</button>
        </div>
      </app-add-question-button>
    </div>
  </div>
</div>
